import { CustomGroup as CustomGroupSynthesisCore}  from 'quote-export-manager-core';

import { PricingItemV1Mapper } from './pricing-item-v1.mapper';
import {PricingItem} from '../../../core/models/quote/pricing-item/pricing-item';
import {CustomGroup} from '../../../core/models/quote/group/custom-group';
import {Injectable} from '@angular/core';

@Injectable()
export class CustomGroupV1Mapper {
  constructor(private readonly pricingItemV1Mapper: PricingItemV1Mapper) {}

  toCustomGroup(group: CustomGroup): CustomGroupSynthesisCore {
    return new CustomGroupSynthesisCore(
      group.id,
      group.title,
      group.order,
      group.pricingItems
        ?.map((item: PricingItem) =>
          this.pricingItemV1Mapper.toPricingItem(item),
        ),
      group.isDuplicated,
      group.totalAppliedPrice,
    );
  }
}
